import {DEFAULT_REWARD_POINTS_NAME} from "@shared/wallet"

export function resolveRewardPointsName(rewardPointsName?: string | null): string {
  return rewardPointsName ?? DEFAULT_REWARD_POINTS_NAME
}
